"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cacheReducer;

var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _isMatch2 = _interopRequireDefault(require("lodash/isMatch"));

var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));

var _extend2 = _interopRequireDefault(require("lodash/extend"));

var _setWith2 = _interopRequireDefault(require("lodash/setWith"));

var _zip4 = _interopRequireDefault(require("lodash/zip"));

var _compact2 = _interopRequireDefault(require("lodash/compact"));

var _pick2 = _interopRequireDefault(require("lodash/pick"));

var _partialRight2 = _interopRequireDefault(require("lodash/partialRight"));

var _map2 = _interopRequireDefault(require("lodash/map"));

var _take2 = _interopRequireDefault(require("lodash/take"));

var _orderBy2 = _interopRequireDefault(require("lodash/orderBy"));

var _flow2 = _interopRequireDefault(require("lodash/flow"));

var _filter2 = _interopRequireDefault(require("lodash/filter"));

var _unset2 = _interopRequireDefault(require("lodash/unset"));

var _set2 = _interopRequireDefault(require("lodash/set"));

var _immer = _interopRequireWildcard(require("immer"));

var _debug = _interopRequireDefault(require("debug"));

var _constants = require("../constants");

var _query = require("../utils/query");

var _profiling = _interopRequireDefault(require("../utils/profiling"));

var _HANDLERS;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var info = (0, _debug.default)('rrf:cache');
var PROCESSES = {
  '<': function _(a, b) {
    return a < b;
  },
  '<=': function _(a, b) {
    return a <= b;
  },
  '==': function _(a, b) {
    return a === b;
  },
  '!=': function _(a, b) {
    return a !== b;
  },
  '>=': function _(a, b) {
    return a >= b;
  },
  '>': function _(a, b) {
    return a > b;
  },
  'array-contains': function arrayContains(a, b) {
    return a.includes(b);
  },
  in: function _in(a, b) {
    return Array.isArray(b) && b.includes(a);
  },
  'array-contains-any': function arrayContainsAny(a, b) {
    return b.some(function (b1) {
      return a.includes(b1);
    });
  },
  'not-in': function notIn(a, b) {
    return !b.includes(a);
  },
  '*': function _() {
    return true;
  }
};

var getDocumentTransducer = function getDocumentTransducer(ids) {
  return (0, _partialRight2.default)(_map2.default, function (coll) {
    return ids.map(function (id) {
      return coll[id];
    }).filter(Boolean);
  });
};

var getCollectionTransducer = function getCollectionTransducer(collection) {
  return (0, _partialRight2.default)(_map2.default, function (state) {
    return state.database[collection];
  });
};

var fieldsTransducer = function fieldsTransducer(fields) {
  return (0, _partialRight2.default)(_map2.default, function (docs) {
    return docs.map(function (doc) {
      return (0, _pick2.default)(doc, ['id', 'path'].concat(_toConsumableArray(fields)));
    });
  });
};

var orderTransducer = function orderTransducer(order) {
  var isFlat = typeof order[0] === 'string';
  var orders = isFlat ? [order] : order;

  var _zip2 = _zip4.default.apply(void 0, _toConsumableArray(orders.map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        field = _ref2[0],
        dir = _ref2[1];

    return [function (data) {
      return typeof data[field] === 'string' ? data[field].toLowerCase() : data[field];
    }, dir || 'asc'];
  }))),
      _zip3 = _slicedToArray(_zip2, 2),
      fields = _zip3[0],
      direction = _zip3[1];

  return (0, _partialRight2.default)(_map2.default, function (docs) {
    return (0, _orderBy2.default)(docs, fields, direction);
  });
};

var limitTransducer = function limitTransducer(limit) {
  return function () {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [],
        _ref4 = _slicedToArray(_ref3, 1),
        arr = _ref4[0];

    return [(0, _take2.default)(arr, limit)];
  };
};

var filterTransducers = function filterTransducers(where) {
  var isFlat = typeof where[0] === 'string';
  var clauses = isFlat ? [where] : where;
  return clauses.map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 3),
        field = _ref6[0],
        op = _ref6[1],
        val = _ref6[2];

    var fnc = PROCESSES[op] || function () {
      return true;
    };

    return (0, _partialRight2.default)(_map2.default, function (collection) {
      return (0, _filter2.default)(Object.values(collection || {}), function (doc) {
        var value;

        if (field === '__name__') {
          value = doc.id;
        } else if (field.includes('.')) {
          value = field.split('.').reduce(function (obj, subField) {
            return obj && obj[subField];
          }, doc);
        } else {
          value = doc[field];
        }

        if (value === undefined) value = null;
        return fnc(value, val);
      });
    });
  });
};

var populateTransducer = function populateTransducer(collection, populates) {
  return (0, _partialRight2.default)(_map2.default, function (state) {
    var done = (0, _profiling.default)("populate.".concat(collection));
    var lookups = (Array.isArray(populates[0]) ? populates : [populates]).map(function (tuple) {
      return [tuple[0], state.database[tuple[1]], tuple[2]];
    }).filter(function (tuple) {
      return tuple[1] !== undefined && Object.keys(tuple[1] || []).length > 0;
    });
    var raw = state.database[collection] || {};
    var ids = Object.keys(raw);
    var collectionById = ids.reduce(function (draft, id) {
      lookups.forEach(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 3),
            field = _ref8[0],
            siblings = _ref8[1],
            destination = _ref8[2];

        var fields = field.split('.');
        var childID = fields.reduce(function (res, prop) {
          return res && res[prop];
        }, draft[id]);

        if (Array.isArray(childID)) {
          draft[id][destination] = childID.map(function (childId) {
            var child = siblings[childId];
            return child || undefined;
          });
        }

        var child = siblings[childID];

        if (child) {
          draft[id][destination] = child;
        }
      });
      return draft;
    }, (0, _immer.createDraft)(raw));
    done();
    return {
      database: _defineProperty({}, collection, (0, _immer.finishDraft)(collectionById))
    };
  });
};

var overridesTransducers = function overridesTransducers(overrides, collection) {
  var partials = overrides && overrides[collection] || {};
  return Object.keys(partials).map(function (docId) {
    return (0, _partialRight2.default)(_map2.default, function (coll) {
      return partials[docId] === null ? (0, _unset2.default)(coll, docId) : (0, _set2.default)(coll, [docId], (0, _extend2.default)({}, coll[docId], partials[docId]));
    });
  });
};

function buildTransducer(overrides, query) {
  var collection = query.collection,
      where = query.where,
      order = query.orderBy,
      limit = query.limit,
      ordered = query.ordered,
      fields = query.fields,
      populates = query.populates;
  var useOverrides = ordered === undefined || Object.keys((overrides || {})[collection] || {}).length > 0;
  var xfPopulate = !populates ? null : populateTransducer(collection, populates);
  var xfGetCollection = getCollectionTransducer(collection);
  var xfGetDoc = getDocumentTransducer((ordered || []).map(function (_ref9) {
    var _ref10 = _slicedToArray(_ref9, 2),
        __ = _ref10[0],
        id = _ref10[1];

    return id;
  }));
  var xfFields = !fields ? null : fieldsTransducer(fields);
  var xfApplyOverrides = !useOverrides ? null : overridesTransducers(overrides || _defineProperty({}, collection, []), collection);
  var xfFilter = !useOverrides || filterTransducers(!where ? ['', '*', ''] : where);
  var xfOrder = !useOverrides || !order ? null : orderTransducer(order);
  var xfLimit = !limit ? null : limitTransducer(limit);

  if (!useOverrides) {
    return (0, _flow2.default)((0, _compact2.default)([xfPopulate, xfGetCollection, xfGetDoc, xfLimit, xfFields]));
  }

  return (0, _flow2.default)((0, _compact2.default)([xfPopulate, xfGetCollection, (0, _partialRight2.default)(_map2.default, function (db) {
    return (0, _immer.createDraft)(db || {});
  })].concat(_toConsumableArray(xfApplyOverrides), [(0, _partialRight2.default)(_map2.default, function (db) {
    return (0, _immer.finishDraft)(db);
  })], _toConsumableArray(xfFilter), [xfOrder, xfLimit, xfFields])));
}

function selectDocuments(reducerState, query) {
  var transduce = buildTransducer(reducerState.databaseOverrides, query);
  return transduce([reducerState])[0];
}

function reprocessQuerires(draft, path) {
  var done = (0, _profiling.default)("reprocess.".concat(path));
  var queries = [];
  var paths = Array.isArray(path) ? path : [path];
  Object.keys(draft).forEach(function (key) {
    if (['database', 'databaseOverrides'].includes(key)) return;
    var _draft$key = draft[key],
        collection = _draft$key.collection,
        _draft$key$populates = _draft$key.populates,
        populates = _draft$key$populates === void 0 ? [] : _draft$key$populates;
    var pops = Array.isArray(populates[0]) ? populates : [populates];
    var collections = pops.map(function (_ref12) {
      var _ref13 = _slicedToArray(_ref12, 2),
          __ = _ref13[0],
          coll = _ref13[1];

      return coll;
    }).concat(collection);

    if (!collections.some(function (coll) {
      return paths.includes(coll);
    })) {
      return;
    }

    queries.push(key);
    var docs = selectDocuments(draft, draft[key]);
    var ordered = docs.map(function (_ref14) {
      var id = _ref14.id,
          _path = _ref14.path;
      return [_path, id];
    });
    var isInitialLoad = draft[key].via === 'memory' && docs.length === 0;
    (0, _set2.default)(draft, [key, 'docs'], isInitialLoad ? undefined : docs);
    (0, _set2.default)(draft, [key, 'ordered'], ordered);
  });

  if (info.enabled) {
    var overrides = JSON.parse(JSON.stringify(draft.databaseOverrides || {}));
    info("reprocess ".concat(path, " (").concat(queries.length, " queries) with overrides"), overrides);
  }

  done();
}

var primaryValue = function primaryValue(arr) {
  return typeof arr[0] === 'string' && arr[0].indexOf('::') === 0 ? null : arr;
};

var nestedMap = function nestedMap(obj, key, val) {
  delete obj[key];
  var fields = key.split('.');
  fields.reduce(function (deep, field, idx) {
    if (deep[field] === undefined) deep[field] = {};
    if (idx === fields.length - 1) deep[field] = val;
    return deep[field];
  }, obj);
  return obj;
};

var arrayUnion = function arrayUnion(key, val, cached) {
  return key !== '::arrayUnion' ? null : (cached() || []).concat([val]);
};

var arrayRemove = function arrayRemove(key, val, cached) {
  return key === '::arrayRemove' && (cached() || []).filter(function (item) {
    return item !== val;
  });
};

var increment = function increment(key, val, cached) {
  return key === '::increment' && typeof val === 'number' && (cached() || 0) + val;
};

var serverTimestamp = function serverTimestamp(key) {
  return key === '::serverTimestamp' && new Date();
};

function atomize(mutation, cached) {
  return Object.keys(mutation).reduce(function (data, key) {
    var val = data[key];

    if (key.includes('.')) {
      nestedMap(data, key, val);
    } else if (Array.isArray(val) && val.length > 0) {
      data[key] = primaryValue(val) || serverTimestamp(val[0]) || arrayUnion(val[0], val[1], function () {
        return cached(key);
      }) || arrayRemove(val[0], val[1], function () {
        return cached(key);
      }) || increment(val[0], val[1], function () {
        return cached(key);
      });
    }

    return data;
  }, JSON.parse(JSON.stringify(mutation)));
}

function translateMutationToOverrides(_ref15, db) {
  var payload = _ref15.payload;

  var _ref16 = payload.data || {},
      reads = _ref16.reads,
      writes = _ref16.writes;

  if (!writes) {
    writes = Array.isArray(payload.data) ? payload.data : [payload.data];
  } else if (!Array.isArray(writes)) {
    writes = [writes];
  }

  var reader = {};

  if (reads) {
    reader = Object.keys(reads).reduce(function (result, key) {
      var _result$key = result[key],
          collection = _result$key.collection,
          doc = _result$key.doc;

      if (!doc) {
        throw new Error("Firestore Transactions don't support query lookups.");
      }

      var coll = db[collection] || {};
      return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, key, coll[doc]));
    }, reads);
  }

  var overrides = writes.map(function (writer) {
    return (0, _isFunction2.default)(writer) ? writer(reader) : writer;
  }).map(function (_ref17) {
    var collection = _ref17.collection,
        path = _ref17.path,
        doc = _ref17.doc,
        id = _ref17.id,
        data = _ref17.data,
        rest = _objectWithoutProperties(_ref17, ["collection", "path", "doc", "id", "data"]);

    return {
      collection: path || collection,
      doc: id || doc,
      data: atomize(data || rest, function (key) {
        var overrides = Object.keys(db).length > 0 ? db : {};
        var coll = overrides[path || collection] || {};
        return (coll[id || doc] || {})[key];
      })
    };
  });
  return overrides;
}

function cleanOverride(draft, _ref18) {
  var path = _ref18.path,
      id = _ref18.id,
      data = _ref18.data;
  if (!path || !id) return;
  var override = (0, _get2.default)(draft, ['databaseOverrides', path, id], false);
  if (!override || data && !(0, _isMatch2.default)(data, override)) return;
  var keys = Object.keys(override);
  var props = !data ? keys : keys.filter(function (key) {
    var current = (0, _get2.default)(data, key);
    var optimistic = override[key];

    if (current === null || current === undefined) {
      return current === optimistic;
    }

    if (Array.isArray(current)) {
      return current.every(function (val, idx) {
        return val === optimistic[idx];
      });
    }

    if (_typeof(current) === 'object') {
      return Object.keys(current).every(function (key) {
        return current[key] === optimistic[key];
      });
    }

    return (0, _isEqual2.default)(data[key], override[key]);
  });
  var isDone = props.length === Object.keys(override).length;
  var isEmpty = isDone && Object.keys(draft.databaseOverrides[path] || {}).length === 1;

  if (isEmpty) {
    (0, _unset2.default)(draft, ['databaseOverrides', path]);
  } else if (isDone) {
    (0, _unset2.default)(draft, ['databaseOverrides', path, id]);
  } else {
    props.forEach(function (prop) {
      (0, _unset2.default)(draft, ['databaseOverrides', path, id, prop]);
    });
  }
}

var initialize = function initialize(state, _ref19) {
  var action = _ref19.action,
      key = _ref19.key,
      path = _ref19.path;
  return (0, _immer.default)(state, function (draft) {
    var done = (0, _profiling.default)("cache.".concat(action.type.replace(/(@@.+\/)/, '')), key);

    if (!draft.database) {
      (0, _set2.default)(draft, ['database'], {});
      (0, _set2.default)(draft, ['databaseOverrides'], {});
    }

    var via = {
      undefined: 'memory',
      true: 'cache',
      false: 'server'
    }[action.payload.fromCache];

    if (action.payload.data) {
      Object.keys(action.payload.data).forEach(function (id) {
        (0, _setWith2.default)(draft, ['database', path, id], action.payload.data[id], Object);
        cleanOverride(draft, {
          path: path,
          id: id,
          data: action.payload.data[id]
        });
      });
    }

    var ordered = (action.payload.ordered || selectDocuments(draft, action.meta)).map(function (_ref20) {
      var path = _ref20.path,
          id = _ref20.id;
      return [path, id];
    });
    (0, _set2.default)(draft, [action.meta.storeAs], _objectSpread(_objectSpread({
      ordered: ordered
    }, action.meta), {}, {
      via: via
    }));
    reprocessQuerires(draft, path);
    done();
    return draft;
  });
};

var conclude = function conclude(state, _ref21) {
  var action = _ref21.action,
      key = _ref21.key,
      path = _ref21.path;
  return (0, _immer.default)(state, function (draft) {
    var done = (0, _profiling.default)("cache.UNSET_LISTENER", key);

    if (draft[key]) {
      var activeIds = Object.keys(draft).reduce(function (inUse, dbKey) {
        var _draft$dbKey = draft[dbKey],
            collection = _draft$dbKey.collection,
            ordered = _draft$dbKey.ordered;

        if (dbKey !== key && collection === path) {
          return [].concat(_toConsumableArray(inUse), _toConsumableArray(ordered.map(function (_ref22) {
            var _ref23 = _slicedToArray(_ref22, 2),
                ___ = _ref23[0],
                id = _ref23[1];

            return id;
          })));
        }

        return inUse;
      }, []);
      (0, _unset2.default)(draft, [key]);
      reprocessQuerires(draft, path);
    }

    done();
    return draft;
  });
};

var modify = function modify(state, _ref24) {
  var action = _ref24.action,
      key = _ref24.key,
      path = _ref24.path;
  return (0, _immer.default)(state, function (draft) {
    var done = (0, _profiling.default)("cache.DOCUMENT_MODIFIED", key);
    (0, _setWith2.default)(draft, ['database', path, action.meta.doc], action.payload.data, Object);
    cleanOverride(draft, {
      path: path,
      id: action.meta.doc,
      data: action.payload.data
    });
    var payload = action.payload;

    var _ref25 = payload.ordered || {},
        _ref25$oldIndex = _ref25.oldIndex,
        oldIndex = _ref25$oldIndex === void 0 ? 0 : _ref25$oldIndex,
        _ref25$newIndex = _ref25.newIndex,
        newIndex = _ref25$newIndex === void 0 ? 0 : _ref25$newIndex;

    if (newIndex !== oldIndex) {
      var tuple = payload.data && [payload.data.path, payload.data.id] || draft[key].ordered[oldIndex];

      var _ref26 = draft[key] || {
        ordered: []
      },
          ordered = _ref26.ordered;

      var idx = (0, _findIndex2.default)(ordered, [1, action.meta.doc]);
      var isIndexChange = idx !== -1;
      var isAddition = oldIndex === -1 || isIndexChange;
      var isRemoval = newIndex === -1 || isIndexChange;

      if (isRemoval && idx > -1) {
        ordered.splice(idx, 0);
      } else if (isAddition) {
        ordered.splice(newIndex, 0, tuple);
      }

      (0, _set2.default)(draft, [key, 'ordered'], ordered);
    }

    if (action.meta.reprocess !== false) {
      reprocessQuerires(draft, path);
    }

    done();
    return draft;
  });
};

var failure = function failure(state, _ref27) {
  var action = _ref27.action,
      key = _ref27.key,
      path = _ref27.path;
  return (0, _immer.default)(state, function (draft) {
    var done = (0, _profiling.default)("cache.MUTATE_FAILURE", key);

    if (action.payload.data || action.payload.args) {
      var write = action.payload.data ? [{
        writes: [action.payload.data]
      }] : action.payload.args;
      var allPaths = write.reduce(function (results, _ref28) {
        var writes = _ref28.writes;
        return [].concat(_toConsumableArray(results), _toConsumableArray(writes.map(function (_ref29) {
          var collection = _ref29.collection,
              _path = _ref29.path,
              doc = _ref29.doc,
              id = _ref29.id;
          info('remove override', "".concat(collection, "/").concat(doc));
          cleanOverride(draft, {
            path: _path || collection,
            id: id || doc
          });
          return path || collection;
        })));
      }, []);
      var uniquePaths = Array.from(new Set(allPaths));

      if (uniquePaths.length > 0) {
        reprocessQuerires(draft, uniquePaths);
      }
    }

    done();
    return draft;
  });
};

var deletion = function deletion(state, _ref30) {
  var action = _ref30.action,
      key = _ref30.key,
      path = _ref30.path;
  return (0, _immer.default)(state, function (draft) {
    var done = (0, _profiling.default)("cache.DELETE_SUCCESS", key);

    if (draft.database && draft.database[path]) {
      (0, _unset2.default)(draft, ['database', path, action.meta.doc]);
    }

    cleanOverride(draft, {
      path: path,
      id: action.meta.doc
    });

    if (draft[key] && draft[key].ordered) {
      var idx = (0, _findIndex2.default)(draft[key].ordered, [1, action.meta.doc]);
      draft[key].ordered.splice(idx, 1);
    }

    reprocessQuerires(draft, path);
    done();
    return draft;
  });
};

var remove = function remove(state, _ref31) {
  var action = _ref31.action,
      key = _ref31.key,
      path = _ref31.path;
  return (0, _immer.default)(state, function (draft) {
    var done = (0, _profiling.default)("cache.DOCUMENT_REMOVED", key);
    cleanOverride(draft, {
      path: path,
      id: action.meta.doc,
      data: action.payload.data
    });

    if (draft[key] && draft[key].ordered) {
      var idx = (0, _findIndex2.default)(draft[key].ordered, [1, action.meta.doc]);
      var wasNotAlreadyRemoved = idx !== -1;

      if (wasNotAlreadyRemoved) {
        draft[key].ordered.splice(idx, 1);
      }
    }

    reprocessQuerires(draft, path);
    done();
    return draft;
  });
};

var optimistic = function optimistic(state, _ref32) {
  var action = _ref32.action,
      key = _ref32.key,
      path = _ref32.path;
  return (0, _immer.default)(state, function (draft) {
    (0, _setWith2.default)(draft, ['databaseOverrides', path, action.meta.doc], action.payload.data, Object);
    reprocessQuerires(draft, path);
    return draft;
  });
};

var reset = function reset(state, _ref33) {
  var action = _ref33.action,
      key = _ref33.key,
      path = _ref33.path;
  return (0, _immer.default)(state, function (draft) {
    cleanOverride(draft, {
      path: path,
      id: action.meta.doc
    });
    reprocessQuerires(draft, path);
    return draft;
  });
};

var mutation = function mutation(state, _ref34) {
  var action = _ref34.action,
      key = _ref34.key,
      path = _ref34.path;
  return (0, _immer.default)(state, function (draft) {
    var done = (0, _profiling.default)("cache.MUTATE_START", key);

    if (action.payload && action.payload.data) {
      var optimisiticUpdates = translateMutationToOverrides(action, draft.database) || [];
      optimisiticUpdates.forEach(function (_ref35) {
        var collection = _ref35.collection,
            doc = _ref35.doc,
            data = _ref35.data;
        info('overriding', "".concat(collection, "/").concat(doc), data);
        (0, _setWith2.default)(draft, ['databaseOverrides', collection, doc], data, Object);
      });

      var updatePaths = _toConsumableArray(new Set(optimisiticUpdates.map(function (_ref36) {
        var collection = _ref36.collection;
        return collection;
      })));

      updatePaths.forEach(function (path) {
        reprocessQuerires(draft, path);
      });
    }

    done();
    return draft;
  });
};

var HANDLERS = (_HANDLERS = {}, _defineProperty(_HANDLERS, _constants.actionTypes.SET_LISTENER, initialize), _defineProperty(_HANDLERS, _constants.actionTypes.LISTENER_RESPONSE, initialize), _defineProperty(_HANDLERS, _constants.actionTypes.GET_SUCCESS, initialize), _defineProperty(_HANDLERS, _constants.actionTypes.UNSET_LISTENER, conclude), _defineProperty(_HANDLERS, _constants.actionTypes.DOCUMENT_ADDED, modify), _defineProperty(_HANDLERS, _constants.actionTypes.DOCUMENT_MODIFIED, modify), _defineProperty(_HANDLERS, _constants.actionTypes.DELETE_SUCCESS, deletion), _defineProperty(_HANDLERS, _constants.actionTypes.DOCUMENT_REMOVED, remove), _defineProperty(_HANDLERS, _constants.actionTypes.OPTIMISTIC_ADDED, optimistic), _defineProperty(_HANDLERS, _constants.actionTypes.OPTIMISTIC_MODIFIED, optimistic), _defineProperty(_HANDLERS, _constants.actionTypes.OPTIMISTIC_REMOVED, reset), _defineProperty(_HANDLERS, _constants.actionTypes.MUTATE_FAILURE, failure), _defineProperty(_HANDLERS, _constants.actionTypes.DELETE_FAILURE, failure), _defineProperty(_HANDLERS, _constants.actionTypes.UPDATE_FAILURE, failure), _defineProperty(_HANDLERS, _constants.actionTypes.SET_FAILURE, failure), _defineProperty(_HANDLERS, _constants.actionTypes.ADD_FAILURE, failure), _defineProperty(_HANDLERS, _constants.actionTypes.MUTATE_START, mutation), _HANDLERS);

function cacheReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var fnc = HANDLERS[action.type];
  if (!fnc) return state;
  var key = !action.meta || !action.meta.collection ? null : action.meta.storeAs || (0, _query.getBaseQueryName)(action.meta);
  var path = !action.meta ? null : action.meta.collection;
  return fnc(state, {
    action: action,
    key: key,
    path: path
  });
}